import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type featureSectionTitleClass = 'title' | 'indicativeNumber';

const featureSectionTitleStyles = makeStyles<ISpcTheme, featureSectionTitleClass>(
  ({ palette }) => ({
    title: {
      color: palette.secondary.main,
      display: 'block',
      fontWeight: 'normal',
      textTransform: 'uppercase',
    },
    indicativeNumber: {
      top: 0,
      verticalAlign: 'super',
    },
  }),
  { name: 'Customise_Feature_Section_Title' },
);

export default featureSectionTitleStyles;
